/**
 * @flow
 * @relayHash 214def00f449242c4e06724d2a14a06e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CSPendingTransactionList_viewer$ref = any;
export type CSPendingTransactionListQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  search?: ?string,
  reportDate?: ?any,
  ignored?: ?boolean,
  processedAt_Isnull?: ?boolean,
|};
export type CSPendingTransactionListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CSPendingTransactionList_viewer$ref
  |}
|};
export type CSPendingTransactionListQuery = {|
  variables: CSPendingTransactionListQueryVariables,
  response: CSPendingTransactionListQueryResponse,
|};
*/


/*
query CSPendingTransactionListQuery(
  $first: Int
  $offset: Int
  $search: String
  $reportDate: Date
  $ignored: Boolean
  $processedAt_Isnull: Boolean
) {
  viewer {
    ...CSPendingTransactionList_viewer_4gCcW0
    id
  }
}

fragment CSPendingTransactionList_viewer_4gCcW0 on Query {
  clearstreamPendingTransactions(first: $first, offset: $offset, search: $search, reportDate: $reportDate, ignored: $ignored, orderBy: "-createdAt", processedAt_Isnull: $processedAt_Isnull) {
    edges {
      node {
        brokeractivityPtr {
          id
          group {
            id
            description
          }
          brokeractivitytransactionSet {
            edges {
              node {
                id
                account {
                  id
                  name
                }
                brokeractivitytransactioncashdeltaSet {
                  edges {
                    node {
                      id
                      currency
                      quantity
                      portfolio {
                        id
                      }
                    }
                  }
                }
                brokeractivitytransactioncontractdeltaSet {
                  edges {
                    node {
                      id
                      portfolio {
                        id
                      }
                      contract {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
        id
        createdAt
        updatedAt
        reportDate
        processedBy {
          id
          fullName
        }
        processedAt
        ignored
        yourReference
        isin
        status
        settlementDate
        requestedAmount
        quantity
        currency
        brokerOrder {
          transferAdviceFile {
            id
            csvUrl
            csv
          }
          id
        }
      }
    }
    count
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "reportDate",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "ignored",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "processedAt_Isnull",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v2 = {
  "kind": "Variable",
  "name": "ignored",
  "variableName": "ignored"
},
v3 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v4 = {
  "kind": "Variable",
  "name": "processedAt_Isnull",
  "variableName": "processedAt_Isnull"
},
v5 = {
  "kind": "Variable",
  "name": "reportDate",
  "variableName": "reportDate"
},
v6 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v10 = [
  (v7/*: any*/)
],
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolio",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioNode",
  "plural": false,
  "selections": (v10/*: any*/)
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CSPendingTransactionListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CSPendingTransactionList_viewer",
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CSPendingTransactionListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "clearstreamPendingTransactions",
            "storageKey": null,
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": "-createdAt"
              },
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "concreteType": "CSPendingTransactionNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CSPendingTransactionNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CSPendingTransactionNode",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokeractivityPtr",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityNode",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "group",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityGroupNode",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "description",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "brokeractivitytransactionSet",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityTransactionNodeConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BrokerActivityTransactionNodeEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BrokerActivityTransactionNode",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "account",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "AccountNode",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "name",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "brokeractivitytransactioncashdeltaSet",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BrokerActivityTransactionCashDeltaNodeConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BrokerActivityTransactionCashDeltaNodeEdge",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "node",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "BrokerActivityTransactionCashDeltaNode",
                                                "plural": false,
                                                "selections": [
                                                  (v7/*: any*/),
                                                  (v8/*: any*/),
                                                  (v9/*: any*/),
                                                  (v11/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "brokeractivitytransactioncontractdeltaSet",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BrokerActivityTransactionContractDeltaNodeConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BrokerActivityTransactionContractDeltaNodeEdge",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "node",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "BrokerActivityTransactionContractDeltaNode",
                                                "plural": false,
                                                "selections": [
                                                  (v7/*: any*/),
                                                  (v11/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "contract",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ContractNode",
                                                    "plural": false,
                                                    "selections": (v10/*: any*/)
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "updatedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "reportDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "processedBy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fullName",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "processedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "ignored",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "yourReference",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isin",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "settlementDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "requestedAmount",
                        "args": null,
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokerOrder",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CSBrokerOrderNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "transferAdviceFile",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CSCashTransferPreAdviseFileNode",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "csvUrl",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "csv",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CSPendingTransactionListQuery",
    "id": null,
    "text": "query CSPendingTransactionListQuery(\n  $first: Int\n  $offset: Int\n  $search: String\n  $reportDate: Date\n  $ignored: Boolean\n  $processedAt_Isnull: Boolean\n) {\n  viewer {\n    ...CSPendingTransactionList_viewer_4gCcW0\n    id\n  }\n}\n\nfragment CSPendingTransactionList_viewer_4gCcW0 on Query {\n  clearstreamPendingTransactions(first: $first, offset: $offset, search: $search, reportDate: $reportDate, ignored: $ignored, orderBy: \"-createdAt\", processedAt_Isnull: $processedAt_Isnull) {\n    edges {\n      node {\n        brokeractivityPtr {\n          id\n          group {\n            id\n            description\n          }\n          brokeractivitytransactionSet {\n            edges {\n              node {\n                id\n                account {\n                  id\n                  name\n                }\n                brokeractivitytransactioncashdeltaSet {\n                  edges {\n                    node {\n                      id\n                      currency\n                      quantity\n                      portfolio {\n                        id\n                      }\n                    }\n                  }\n                }\n                brokeractivitytransactioncontractdeltaSet {\n                  edges {\n                    node {\n                      id\n                      portfolio {\n                        id\n                      }\n                      contract {\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        id\n        createdAt\n        updatedAt\n        reportDate\n        processedBy {\n          id\n          fullName\n        }\n        processedAt\n        ignored\n        yourReference\n        isin\n        status\n        settlementDate\n        requestedAmount\n        quantity\n        currency\n        brokerOrder {\n          transferAdviceFile {\n            id\n            csvUrl\n            csv\n          }\n          id\n        }\n      }\n    }\n    count\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cce2a167f9b7c392f5f182d75d58f64e';
module.exports = node;
